<template>
  <Menu class="w-[280px]">
    <Menu.Item :icon="TrashIcon" @click="handleDeleteClick"> Delete </Menu.Item>
    <Menu.Item v-if="hasOneItem" :icon="PencilIcon" @click="handleRenameClick">
      Rename
    </Menu.Item>
    <Menu.Item :icon="MoveIcon" @click="handleMoveClick"> Move </Menu.Item>
  </Menu>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Menu } from '@dacr/library'
import { TrashIcon, PencilIcon, MoveIcon } from '@dacr/icons'
import { openModal, Modals } from '@/shared/dialogs/modals'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import type { Item } from '@/shared/graphql/router/graphql'

const props = defineProps<{
  items: Item[]
}>()
const emit = defineEmits<{
  clicked: []
}>()

const hasOneItem = computed(() => props.items.length === 1)

const handleDeleteClick = () => {
  openModal(Modals.DeleteFolders, {
    props: { items: props.items },
  })
  emit('clicked')
}

const handleMoveClick = () => {
  document.body.click()

  openDialog(Dialog.MoveItems, {
    props: { ids: props.items.map((item) => item.id) },
  })
  emit('clicked')
}

const handleRenameClick = () => {
  openDialog(Dialog.RenameFolder, {
    props: { item: props.items[0] },
  })
  emit('clicked')
}
</script>
